import { jsx as _jsx } from "react/jsx-runtime";
import styles from './BouncyArc.scss';
const BouncyArc = ({ size = 70, color = 'black', speed = 1.65, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
        }, children: _jsx("div", { className: styles.inner, children: _jsx("div", { className: styles.cube }) }) }));
};
export default BouncyArc;
